import React from 'react';
import { Button } from 'antd';
import { Icon as IconifyIcon } from '@iconify/react';

import { OrderService } from '../../../shared/services/OrderService';
import { isBackOfficeOrUpgasEmployee } from '../../../shared/services/UserService';
import OrderStatusEnum from '../../../shared/Enum/OrderStatusEnum';

const ResumoDetalhePedido = ({ order, canShowSensitiveData, onShowMap }) => {
  const { statusId } = order;
  const maskedAddress = (order.customer.address || '').replace(/\d+/, '•••');

  const isAccepted =
    statusId === OrderStatusEnum.AceitoPelaOrganizacao ||
    statusId === OrderStatusEnum.AceitoPeloAdm ||
    statusId === OrderStatusEnum.AceitoPeloFuncionarioUpgas;

  return (
    <div className='dp-info-card'>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <span className='dp-info-card-title'>Informações do Cliente</span>
        {canShowSensitiveData && (
          <Button
            size='small'
            type='link'
            style={{ padding: 0, fontSize: 16, height: 'auto' }}
            onClick={() => OrderService().copyToClipboard(order)}>
            Copiar pedido
          </Button>
        )}
      </div>

      <div>
        <div className='dp-info-card-name'>{order.customer.name}</div>
        <div className='dp-info-card-orders'>
          ({order.customer.totalOrders} pedidos)
        </div>
      </div>

      {(isBackOfficeOrUpgasEmployee() || isAccepted) && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-icon'>
            <IconifyIcon
              icon='fa6-solid:location-dot'
              style={{ width: 14, height: 14 }}
            />
          </span>
          <span className='dp-info-card-row-text'>
            {canShowSensitiveData
              ? order.customer.address
              : maskedAddress}

            {!canShowSensitiveData && (
              <em style={{ color: '#9ca3af', display: 'block' }}>
                Número disponível em 5 minutos após a criação do pedido
              </em>
            )}

            {order.customer.complement && (
              <span>
                <br />
                {order.customer.complement}
              </span>
            )}
          </span>
        </div>
      )}

      {(order.customer.phone ||
        (isBackOfficeOrUpgasEmployee() && order.customer.originalPhone)) && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-icon'>
            <IconifyIcon
              icon='fa6-solid:phone'
              style={{ width: 14, height: 14 }}
            />
          </span>
          <span className='dp-info-card-row-link'>
            {canShowSensitiveData
              ? isBackOfficeOrUpgasEmployee()
                ? order.customer.originalPhone
                : order.customer.phone
              : '•••••••••••'}
          </span>
        </div>
      )}

      {order.customerFiscalNoteDocument !== '' && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-text'>
            CPF na nota: {order.customerFiscalNoteDocument}
          </span>
        </div>
      )}

      {order.codigoConfirmacao && isBackOfficeOrUpgasEmployee() && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-text'>
            Código Confirmação: {order.codigoConfirmacao}
          </span>
        </div>
      )}

      {canShowSensitiveData && onShowMap && (
        <button type='button' className='dp-info-card-map-btn' onClick={onShowMap}>
          <IconifyIcon icon='fa6-solid:map' style={{ width: 14, height: 14 }} />
          Ver no Mapa
        </button>
      )}
    </div>
  );
};

export default ResumoDetalhePedido;
